import api from './client'

export interface TopUpTier {
	min: number
	max: number
	bonus: number
}

export interface TopUpConfig {
	base_rate: number
	min_amount: number
	max_amount: number
	step: number
	round_to: number
	presets: number[]
	tiers: TopUpTier[]
	// Приходят с 08.2026, когда конфиг переехал из хардкода в админку
	// (Тарифы → «Докупка токенов»). Опциональны, чтобы старый фронт не падал
	// на новом бэке и наоборот.
	bonus_enabled?: boolean
	default_amount?: number | null
}

export interface TopUpBuyResult {
	payment_url: string
	order_id: string
	// Итог к оплате — уже со скидкой по промокоду
	amount: number
	credits: number
	bonus_credits?: number
	discount?: number
}

export async function getTopUpConfig(): Promise<TopUpConfig> {
	return api.request<TopUpConfig>('/api/v1/payments/topup-config')
}

// promo_code — только применённый код (после /promo/check): сервер
// пересчитает сумму и зарезервирует код, неподходящий вернёт 400 с текстом.
export async function buyTopUp(amount: number, paymentMethod: 'sbp' | 'card', promoCode?: string | null): Promise<TopUpBuyResult> {
	return api.request<TopUpBuyResult>('/api/v1/payments/topup', {
		method: 'POST',
		body: { amount, payment_method: paymentMethod, ...(promoCode ? { promo_code: promoCode } : {}) },
	})
}

export function bonusFor(amount: number, cfg: TopUpConfig): number {
	// Рубильник в админке выключен → бэк присылает пустые tiers, но проверяем
	// и флаг явно: считать бонус там, где его отключили, нельзя.
	if (cfg.bonus_enabled === false) return 0
	for (const t of cfg.tiers) {
		if (amount >= t.min && amount < t.max) return t.bonus
	}
	return cfg.tiers.length ? cfg.tiers[cfg.tiers.length - 1].bonus : 0
}

export function computeTokens(amount: number, cfg: TopUpConfig): number {
	const bonus = bonusFor(amount, cfg)
	const raw = (amount / cfg.base_rate) * (1 + bonus)
	return Math.round(raw / cfg.round_to) * cfg.round_to
}

export function clampAmount(amount: number, cfg: TopUpConfig): number {
	return Math.min(cfg.max_amount, Math.max(cfg.min_amount, amount))
}

// Что выбрано при открытии модалки: явная настройка из админки, иначе прежнее
// поведение — вторая кнопка, иначе минимум.
export function initialAmount(cfg: TopUpConfig): number {
	const preferred = cfg.default_amount ?? cfg.presets[1] ?? cfg.min_amount
	return clampAmount(preferred, cfg)
}

// Наименьшая сумма ползунка (шагами от минимума, как у самого ползунка), за которую начислят не меньше need токенов —
// с бонусом и округлением, ровно как посчитает бэк. Не хватает и максимума — максимум.
export function amountForTokens(need: number, cfg: TopUpConfig): number {
	const step = Math.max(1, cfg.step)
	for (let a = cfg.min_amount; a <= cfg.max_amount; a += step) {
		if (computeTokens(a, cfg) >= need) return a
	}
	return cfg.max_amount
}
